<mat-tab-group (selectedTabChange)="getANIData()">
    <mat-tab label="Mainstreet">
        <app-mat-data-grid
          class="page-data-grid"
          [formValid]="mainstreetForm.valid"
          [(dataSource)]="mainstreetData"
          [displayedColumns]="[
            'ani',
            'agentName',
            'agentEmail',
            'agentType',
            'updatedDate'
          ]"
          [columnNames]="[
          'ANI',
          'Agent Name',
          'Agent Email Address',
          'Agent type',
          'Updated Date'
          ]"
          [columnFormatters]="{'agentType': formatAgentTypeFunction}"
          [editDefinition]="{
            ani: mainstreetAni,
            agentName: mainstreetAgentName,
            agentEmail: mainstreetAgentEmail,
            agentType: mainstreetAgentType
          }"
          [pageSizeOptions]="[5, 10, 15]"
          [buttonConfig]="{
            edit: { show: editable },
            delete: { show: editable },
            create: { show: editable },
            loading: { show: true,  template: loading}
          }"
          [objectBluePrint]="{ aniType: 'MSPP'}"
          (buttonClick)="handleMainstreetButtonEvent($event)"
        >
        </app-mat-data-grid>
        <ng-template  #loading>
          <mat-spinner *ngIf="!editable" diameter=50></mat-spinner>
        </ng-template>
       
        <ng-template let-element #mainstreetAni>
          <form [formGroup]="mainstreetForm" [hidden]="!creatingRow">
            <input
              type="text"
              [(ngModel)]="element.ani"
              placeholder="ANI"
              formControlName="mainstreetANI"
              (blur)="validateMainstreetPhoneNumber(element.ani)"
            />
          </form>
          <span *ngIf="!creatingRow">
            {{displayFormatPhoneNumber(element.ani)}}
          </span>
        </ng-template>
  
        <ng-template let-element #mainstreetAgentName>
          <form [formGroup]="mainstreetForm">
            <input
              type="text"
              [(ngModel)]="element.agentName"
              placeholder="Agent Name"
              formControlName="mainstreetName"
            />
          </form>
        </ng-template>
  
        <ng-template let-element #mainstreetAgentType>
          <form [formGroup]="mainstreetForm">
            <select [(ngModel)]="element.agentType" formControlName="mainstreetAgentType">
              <option value="" disabled selected hidden>Select Type</option>
              <option
                class="custom-option"
                *ngFor="let type of mainstreetTypes"
                [ngValue]="type[1]"
              >
                {{ type[0] }}
              </option>
            </select>
          </form>
        </ng-template>
  
        <ng-template let-element #mainstreetAgentEmail>
          <form [formGroup]="mainstreetForm">
            <input
              type="text"
              [(ngModel)]="element.agentEmail"
              placeholder="Agent Email"
              formControlName="mainstreetAgentEmail"
            />
          </form>
        </ng-template>
  
    </mat-tab>
    <mat-tab label="Mainstreet Batch Upload">
      <app-mainstreet-batch-upload></app-mainstreet-batch-upload>
    </mat-tab>
  </mat-tab-group>
  